<template>
  <div>
    <ISTExport v-if="externalSoftware == 1"></ISTExport>
    <div
      v-if="externalSoftware != 1"
      style="font-size: 22px; font-weight: bold; padding: 60px"
    >
      {{ $t('export.comp.exportNotAvailable') }}
    </div>
  </div>
</template>
<script>
import ISTExport from "../../views/ISTExport.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    ISTExport,
  },
  name: "ExportDailyActualShifts",
  data() {
    return {
      mode: "daily",
    };
  },
  computed: {
    ...mapGetters(["externalSoftware"]),
  },
  watch: {},
  mounted() {
    this.refresh();
  },
  methods: {
    refresh: function () {},
  },
};
</script>
<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped></style>
